import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/analytics";
import Vue from 'vue'
import { firestorePlugin } from 'vuefire'
import { config } from '@/config'

if (!firebase.apps.length) {
  firebase.initializeApp(config.firebase);
}
const db = firebase.firestore();

if (config.emulator.enable) {
  console.warn('Using emulator, not real firestore')
  db.settings({
    host: config.emulator.host,
    ssl: false
  });
}

if (!firebase.apps.length) {
  db.enablePersistence({synchronizeTabs:true});
}

Vue.prototype.$analytics = firebase.analytics();

function exception(error) {
  Vue.prototype.$analytics.logEvent("exception", {
    description: error,
    fatal: false,
  });
}

Vue.config.errorHandler = (err, vm, info) => {
  console.error('err', err)
  console.log('vm', vm)
  console.log('info', info)
  exception(err);
};

window.addEventListener('error', error => {
  exception(error.message, true)
})

window.addEventListener('unhandledrejection', function(event) {
  exception(event.reason);
});

firebase.getCurrentUser = () => {
  return new Promise((resolve, reject) => {
    const unsubscribe = firebase.auth().onAuthStateChanged(user => {
      unsubscribe();
      resolve(user);
    }, reject);
  }
)};

Vue.use(firestorePlugin)
const auth = firebase.auth();
export { firebase, db, auth };